// extracted by mini-css-extract-plugin
module.exports = {"Reports":"Reports_Reports__1wjHg","ReportBuilderSection":"Reports_ReportBuilderSection__19ck_"};